import { canvasGetSchema } from "@schemas/canvas/canvasGetSchema";
import { z } from "zod";

const postEngagementCanvasResultSchema = z.object({
  canvas: canvasGetSchema,
});

export const isPostEngagementCanvasResult = (data: unknown) => {
  const result = postEngagementCanvasResultSchema.safeParse(data);
  return result.success;
};
